import React from "react";

export type TemporalSliceValue = string | Date | null | undefined;

const TemporalSliceContext = React.createContext<TemporalSliceValue>(undefined);

export interface TemporalSliceProviderProps {
  value?: TemporalSliceValue;
  children: React.ReactNode;
}

export const TemporalSliceProvider = ({ value, children }: TemporalSliceProviderProps) => {
  return <TemporalSliceContext.Provider value={value}>{children}</TemporalSliceContext.Provider>;
};

export const useTemporalSlice = () => React.useContext(TemporalSliceContext);

export default TemporalSliceProvider;
